import React from 'react';
import { BreadcrumbItem } from 'react-bootstrap';

interface IBread {
    title: string;
    active: boolean;
    url?: string;
}

interface IProps {
    title: string;
    breads: IBread[]
}

const Breadcrumbs = ({ title, breads }: IProps) => {
    return (
        <div className="row">
            <div className="col-xs-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h4 className="mb-0 font-size-18">{title}</h4>
                    <div className="page-title-right">
                        <div className="breadcrumb m-0">
                            {
                                breads?.map((bread, idx) =>
                                    <BreadcrumbItem key={idx} active={bread.active} className="breadcrumb-item"
                                        href={`${!bread.active ? bread?.url : '#'}`}>
                                        {bread.title}
                                    </BreadcrumbItem>)
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Breadcrumbs;